<template>
  <Breadcrumb :model="items">
    <template #item="{ item, props }">
      <div :target="item.target" v-bind="props.action">
        <RouterLink v-if="item.route" :to="{ name: item.route }">
          {{ item.label }}
        </RouterLink>
        <a v-else-if="item.reload" @click="reload">{{ item.label }}</a>
        <span v-else>{{ item.label }}</span>
      </div>
    </template>
  </Breadcrumb>
</template>

<script setup lang="ts">
import Breadcrumb from "primevue/breadcrumb";
defineProps<{
  items: object[];
}>();

const reload = () => {
  location.reload();
};
</script>

<style lang="scss" scoped>
a {
  color: $main-font-color;
  cursor: pointer;
  &:hover {
    color: $main-link-color;
  }
}
</style>
